<template>
  <div class="comment">
    <vtextarea
      class="comment__area"
      v-model="value"
      :border="false"
      :placeholder="$tr('onlineInterview.room.comment')"
    />
  </div>
</template>

<script>
  import debounce from 'debounce';

  export default {
    name: 'comment',

    props: {
      comment: {
        type: Object,
        default: null
      }
    },

    computed: {
      value: {
        get() {
          return this.comment ? this.comment.body : '';
        },
        set(v) {
          if (v.length >= 1) {
            this.validate(v);
          }
        }
      }
    },

    methods: {
      validate: debounce(function(v) {
        this.$emit('sent_comment', {
          value: v,
          id: this.comment ? this.comment.id : ''
        });
      }, 500)
    }
  };
</script>

<style lang="scss" scoped>
  .comment {
    height: 100%;
    width: 500px;
    position: absolute;
    top: 0;
    right: 0;
    transition: all 1s;
    padding: 28px 28px 28px 33px;
    box-sizing: border-box;
    background: #fff;

    &__area {
      height: 100%;
    }
  }

  @media (max-width: 1280px) {
    .comment {
      width: 350px;
    }
  }
</style>
